import PropTypes from 'prop-types'
import React from 'react'
import i18n from 'simple-react-i18n'
import ToastrAction from 'toastr/actions/ToastrAction'
import { getDay } from '../../../../../utils/DateUtil'
import DtoCentralRange from '../../dto/DtoCentralRange'
import DtoCentralRangeItem from '../../dto/DtoCentralRangeItem'
import { CardTable } from 'components/datatable/NewTable'
import { useDispatch } from 'react-redux'
import { darkBlue } from 'utils/constants/ColorTheme'

const RangePanel = ({ centralRanges = [], active }) => {
    const dispatch = useDispatch()

    const getDatas = () => {
        if (centralRanges.length) {
            return centralRanges.map((o) => new DtoCentralRangeItem({ ...o, day: getDay(o.day) }))
        }
        return []
    }

    const datas = getDatas()
    const actions = [
        {
            icon: 'note_add',
            color: darkBlue,
            onClick: () => {
                dispatch(ToastrAction.info(i18n.inDeveloppmentFunctionnality))
            },
        },
    ]
    return (
        <CardTable
            title={i18n.materialRange}
            actions={active ? actions : []}
            rows={datas}
            headers={['day', 'range', 'comment']}
        />
    )
}

RangePanel.propTypes = {
    centralRanges: PropTypes.arrayOf(PropTypes.instanceOf(DtoCentralRange)),
    active: PropTypes.bool,
}

export default RangePanel
